import axios from 'axios';

// GET /admin/candidate/:id/answer-log?format=xlsx|csv -> file blob; triggers a browser download.
// Same fetch-as-blob approach as the PDP button (same-origin via the CRA proxy / prod server, so
// the session cookie is sent). Two safeguards so we never save a non-file as a spreadsheet:
//   - on a 4xx the body is a JSON error blob (e.g. 422 no assessment, or the server's generic
//     message) — parse it and throw a readable message;
//   - on a 2xx whose content-type is NOT a spreadsheet/csv (e.g. a stale/missing route falling
//     through to the SPA index.html, or an HTML error page) — throw the generic message.
const GENERIC = "Couldn't generate the report. Please try again or contact support.";

export const generateAnswerLog = async (candidateId, label, format) => {
  let res;
  try {
    const params = { format };
    if (label) params.label = label;
    res = await axios.get(`/admin/candidate/${candidateId}/answer-log`, {
      params,
      responseType: 'blob',
    });
  } catch (err) {
    let message = GENERIC;
    const data = err.response && err.response.data;
    if (data && typeof data.text === 'function') {
      try {
        const json = JSON.parse(await data.text());
        message =
          json.status_message ||
          json.message ||
          (json.errors && json.errors[0] && json.errors[0].msg) ||
          GENERIC;
      } catch (e) {
        /* keep generic message */
      }
    }
    throw new Error(message);
  }

  const ct = (res.headers['content-type'] || '').toLowerCase();
  const looksLikeFile =
    ct.includes('spreadsheetml') || ct.includes('csv') || ct.includes('octet-stream');
  if (!looksLikeFile) {
    // Not a real file (e.g. the dev proxy served index.html because the route was missing). Do not
    // download an HTML page as a spreadsheet — surface the generic toast instead.
    throw new Error(GENERIC);
  }

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  const cd = res.headers['content-disposition'] || '';
  const match = cd.match(/filename="?([^"]+)"?/);
  a.download = match ? match[1] : `answer-log-${candidateId}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
